import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landing.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__inner">
        <span className="not-found__code">404</span>
        <h1 className="not-found__title">Page Not Found</h1>
        <p className="not-found__text">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn--primary btn--lg">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 8H3M7 4L3 8l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
